<script>
    import Calculator from './Calculator.vue';
    import Comparator from './Comparator.vue';

    export default {
        components: { Comparator, Calculator },
        data: () => ({
            currentTool: 1,
            tabs: true,
            currentStep: 1,
        }),
        computed: {

        },
        methods: {
            toggleTabs(){
                this.tabs = !this.tabs
            },
            handleProgressbar(){
                this.toggleTabs()
                if (this.currentStep === 2) {
                    this.currentStep--
                    return
                }
                this.currentStep++
            },
            handleTools(id){
                this.currentTool = id
            }
        }
    }

</script>
<template>
    <div id="app">
        <div class="container container--comparator">
            
            <header class="header box p-6 mb-8">
                <img src="./assets/images/layout/logo-bbva.png" alt="">
            </header>

            <h1 class="tx-32 tx-medium tx-center tx-blue-1 mb-6">
                <img class="w-25" src="./assets/images/icon-save.png" alt="">
                ¡Averigua cuánto obtendría tu cliente por cada venta!
            </h1>

            <!-- PROGRESS -->
            <div class="relative flex align-center w-fit mx-auto mb-6">
                <img class="w-22 -mt-2 z-1" src="./assets/images/icon-calculator-glass.png" alt="">
                <div class="bar w-54 h-3 rounded-10 bg-white overflow-hidden -ml-6 mr-2 shadow-1">
                    <div class="progressbar bg-green-1 h-100pr rounded-10" :class="this.currentStep === 1 ? 'w-50pr' : 'w-100pr'"></div>
                </div>
                {{ currentStep }}/2
            </div>

<!--             <div class="grid grid-cols-2 gap-2 w-fit mx-auto mb-8" v-if="tabs">
                <button class="btn btn--lightblue-1 w-60" :class="currentTool === 1 && 'active'" @click="handleTools(1)">
                    Calcular
                </button>
                <button class="btn btn--lightblue-1 w-60" :class="currentTool === 2 && 'active'" @click="handleTools(2)">
                    Comparador
                </button>
            </div> -->
            
            <calculator  @stepTwo="handleProgressbar()"/>
        </div>
    </div>
</template>